// src/components/QuillEditor.jsx
import React, { useEffect, useRef } from "react";

export default function QuillEditor({ value, onChange, minHeight = "280px" }) {
  const wrapperRef = useRef(null);
  const quillRef = useRef(null);

  useEffect(() => {
    // 🔥 FIX 1: Track if the component is alive
    let isMounted = true; 

    if (!wrapperRef.current) return;

    // Load CSS
    if (!document.querySelector('link[href*="quill.snow.css"]')) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "https://cdn.quilljs.com/1.3.7/quill.snow.css";
      document.head.appendChild(link);
    }

    const initQuill = () => {
      // 🔥 FIX 2: If React already unmounted this component, DO NOT create Quill
      if (!isMounted) return; 
      if (quillRef.current) return;

      // 🔥 FIX 3: Forcefully clear everything before creating new
      wrapperRef.current.innerHTML = "";

      const editorDiv = document.createElement("div");
      wrapperRef.current.appendChild(editorDiv);

      const q = new window.Quill(editorDiv, {
        theme: "snow",
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline"],
            [{ color: [] }, { background: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["clean"],
          ],
        },
      });

      quillRef.current = q;
      
      if (value) {
        q.root.innerHTML = value;
      }

      q.on("text-change", () => {
        if (onChange) onChange(q.root.innerHTML);
      });
    };

    if (window.Quill) {
      initQuill();
    } else {
      // 🔥 FIX 4: Check if script is ALREADY injected by the first StrictMode render
      let script = document.querySelector('script[src="https://cdn.quilljs.com/1.3.7/quill.min.js"]');
      if (!script) {
        script = document.createElement("script");
        script.src = "https://cdn.quilljs.com/1.3.7/quill.min.js";
        document.head.appendChild(script);
      }
      // Add event listener to the script
      script.addEventListener("load", initQuill);
    }

    return () => {
      // 🔥 FIX 5: Tell any pending downloads that this component is dead
      isMounted = false; 
      if (wrapperRef.current) {
        wrapperRef.current.innerHTML = ""; 
      }
      quillRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Run only once

  useEffect(() => {
    if (quillRef.current && value !== undefined) {
      if (quillRef.current.root.innerHTML !== value) {
        quillRef.current.root.innerHTML = value || "";
      }
    }
  }, [value]);

  return (
    <>
      <div 
        ref={wrapperRef} 
        className="quill-compact-wrapper" 
        style={{ display: "flex", flexDirection: "column", flex: 1, minHeight, background: "#fff" }} 
      />
      <style>{`
        /* Safety Net CSS */
        .quill-compact-wrapper .ql-toolbar ~ .ql-toolbar {
            display: none !important;
        }
        .quill-compact-wrapper .ql-toolbar.ql-snow {
          background: #f8fafc !important; 
          border: none !important; 
          border-bottom: 1px solid #e0e6ed !important;
          display: flex !important; 
          flex-wrap: nowrap !important; 
         
          padding: 6px 10px !important; 
          white-space: nowrap;
        }
        .quill-compact-wrapper .ql-toolbar.ql-snow::-webkit-scrollbar { height: 4px; }
        .quill-compact-wrapper .ql-toolbar.ql-snow::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
        
        .quill-compact-wrapper .ql-formats { 
          display: inline-flex !important; 
          flex-shrink: 0 !important; 
          margin-right: 10px !important; 
        }
        
        .quill-compact-wrapper .ql-container.ql-snow { 
          border: none !important; 
          font-family: system-ui, -apple-system, sans-serif !important; 
          font-size: 13px !important; 
          flex: 1; 
          overflow-y: auto; 
        }
        
        .quill-compact-wrapper .ql-editor { 
          min-height: ${minHeight}; 
          padding: 14px 16px; 
          color: #2c3e50; 
        }
      `}</style>
    </>
  );
}